import React from 'react';
import { ProfileRoundedTab } from '../ProfileRoundedTab';
import { AdvancedColor, ICON_NAME_MAP, Tab } from './types';

interface TabsListProps {
  tabs: Tab[];
  tempValue: number;
  value: number;
  setFade: (value: boolean) => void;
  setTempValue: (value: number) => void;
  setValue: (value: number) => void;
  advancedColor?: AdvancedColor | null;
}

const TabsList: React.FC<TabsListProps> = ({
  tabs,
  tempValue,
  value,
  setFade,
  setTempValue,
  setValue,
  advancedColor,
}) => {
  const handleTabClick = (index: number, type: string, source?: string) => {
    value !== index && setFade(true);

    setTempValue(index);
    setTimeout(() => setValue(index), 600);

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'tab_view',
      tabName: source ? source : type,
      custom_tabName: source ? source : type,
    });
  };

  return (
    <>
      {tabs.map(({ type, source }, index) => {
        const isHighlighted = Boolean(
          advancedColor?.isActive && value === index,
        );

        const buttonStyle = isHighlighted
          ? {
              '--tab-bg': advancedColor?.primary ?? 'transparent',
              '--tab-shadow': `5px 5px 10px ${
                advancedColor?.shadow1 ?? 'transparent'
              }, inset 1px 1px 2px ${advancedColor?.shadow3 ?? 'transparent'}`,
            }
          : undefined;

        return (
          <div
            key={index}
            style={buttonStyle as React.CSSProperties}
            className={
              isHighlighted
                ? 'contents [&_button]:bg-[var(--tab-bg)] [&_button]:shadow-[var(--tab-shadow)]'
                : 'contents'
            }
          >
            <ProfileRoundedTab
              index={index}
              activeInd={tempValue}
              className={tempValue === index ? 'selected' : ''}
              onClick={() => handleTabClick(index, type, source)}
              active={tempValue === index}
              IconType={
                source
                  ? source?.toLowerCase()?.capitalize()
                  : ICON_NAME_MAP[type]
              }
            />
          </div>
        );
      })}
    </>
  );
};

export default TabsList;
